const ENGINE_SIZE_RANGE = {
  fr: [1000, 1200, 1400, 1600, 1800, 2000, 2500, 3000, 4000, 5000, 6000, 7000, 8000],
  de: [1000, 1200, 1400, 1600, 1800, 2000, 2500, 3000, 4000, 5000, 6000, 7000, 8000],
  uk: [1.0, 1.2, 1.4, 1.6, 1.8, 2.0, 2.4, 2.6, 3.0],
};

const QUICK_LINKS_RANGE = {
  fr: [
    '1000',
    '1200',
    '1400',
    '1600',
    '1800',
    '2000',
    '2500',
    '3000',
    '4000',
    '5000',
    '6000',
    '7000',
    '8000',
  ],
  de: [
    '1000',
    '1200',
    '1400',
    '1600',
    '1800',
    '2000',
    '2500',
    '3000',
    '4000',
    '5000',
    '6000',
    '7000',
    '8000',
  ],
  uk: ['1.0', '1.2', '1.4', '1.6', '1.8', '2.0', '2.4', '2.6', '3.0'],
};

export { ENGINE_SIZE_RANGE, QUICK_LINKS_RANGE };
